import { fetch, post } from '@/utils/axios'

export default {
  // 创建订单合约
  createOrder: (data) => {
    return post('/order/createOrder', data, { sim: true })
  },
  // 创建订单现货
  createCoinOrder: (data) => {
    return post('/order/createCoinOrder', data, { sim: true })
  },
  // 查询订单列表
  getOrderList: (params) => {
    return fetch('/order/getOrderList', params, { sim: true })
  },
  // 查询订单详情
  getOrderInfo: (params) => {
    return fetch('/order/getOrderInfo', params, { sim: true })
  },
  // 止盈止损设置
  stopOrderSet: (data) => {
    return post('/order/stopOrderSet', data, { sim: true })
  },
  // 平仓
  settleOrder: (params) => {
    return fetch('/order/settleOrder', params, { sim: true })
  },
  // 取消订单
  cancelOrder: (params) => {
    return fetch('/order/cancelOrder', params, { sim: true })
  },
  // 创建理财订单
  createFinanceOrder: (data) => {
    return post('/orderFinance/createFinanceOrder', data)
  },
  // 查询理财订单列表
  getFinanceOrderList: (params) => {
    return fetch('/orderFinance/getFinanceOrderList', params)
  },
  // 查询理财订单详情
  getFinanceOrderInfo: (params) => {
    return fetch('/orderFinance/getFinanceOrderInfo', params)
  },
  // 创建贷款订单
  createLoanOrder: (data) => {
    return post('/orderFinance/createLoanOrder', data)
  },
  // 查询贷款订单列表
  getLoanOrderList: (params) => {
    return fetch('/orderFinance/getLoanOrderList', params)
  },
  // ctc买入
  buyCtcOrder: (data) => {
    return post('/ctcOrder/buyCtcOrder', data)
  },
  // ctc卖出
  sellCtcOrder: (data) => {
    return post('/ctcOrder/sellCtcOrder', data)
  },
  // 查询ctc订单列表
  getCtcOrderList: (params) => {
    return fetch('/ctcOrder/getCtcOrderList', params)
  },
  // 取消ctc订单
  cancelCtcOrder: (params) => {
    return fetch('/ctcOrder/cancelCtcOrder', params)
  },
  // 创建秒合约订单
  createSecondOrder: (data) => {
    return post('/order/createSecondOrder', data, { sim: true })
  },
  // 查询秒合约订单列表
  getSecondOrderList: (params) => {
    return fetch('/order/getSecondOrderList', params, { sim: true })
  },
  // 查询秒合约订单详情
  getSecondOrderInfo: (params) => {
    return fetch('/order/getSecondOrderInfo', params, { sim: true })
  },
}
